__turbopack_context__.v({
  "feature": "F6rz_a_feature",
  "features": "F6rz_a_features",
  "featuresGroup": "F6rz_a_featuresGroup",
  "imgWrapper": "F6rz_a_imgWrapper",
  "pricingModal": "F6rz_a_pricingModal",
});
